<template>
    <div class="enterprise-admin-page rightPage">
        <el-tabs v-model="activeTab" type="card">
            <!-- Tab 1: Company ID Applications -->
            <el-tab-pane :label="$t('account_redesign.company_apply_list')" name="apply">
                <div class="rightHeader">
                    <v-search :formContent="applyFormContent" :SearchForm="applySearchForm" :inline="true"
                        :optareBtn="optareBtn"
                        @resetFn="applyResetFn" @searchFn="applySearchFn" @confirmFn="applyConfirmFn"
                        @applyFn="openApplyDialog" @auditFn="openBatchAuditDialog" @deleteFn="handleBatchDelete" />
                </div>

                <div class="componentPage">
                    <el-table v-loading="applyLoading" :data="applyList" stripe style="width: 100%"
                        :height="tableHeight" :header-cell-style="headCellStyle" :cell-style="bodyCellStyle"
                        :empty-text="$t('account_redesign.no_data')" @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="45" align="center"></el-table-column>
                        <el-table-column :label="$t('account_redesign.company')" prop="companyName" min-width="180" show-overflow-tooltip />
                        <el-table-column :label="$t('account_redesign.apply_status')" width="100" align="center">
                            <template #default="{ row }">
                                <i :class="getApplyStatusIcon(row.status).icon" :style="{ color: getApplyStatusIcon(row.status).color, fontSize: '18px' }"></i>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('account_redesign.company_id')" width="120" show-overflow-tooltip>
                            <template #default="{ row }">{{ row.companyId || '-' }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('account_redesign.contact_name')" prop="contactName" min-width="100" show-overflow-tooltip />
                        <el-table-column :label="$t('account_redesign.mobile')" prop="contactMobile" min-width="130" show-overflow-tooltip />
                        <el-table-column :label="$t('account_redesign.contact_email')" prop="contactEmail" min-width="200" show-overflow-tooltip />
                        <el-table-column :label="$t('account_redesign.apply_time')" width="160">
                            <template #default="{ row }">{{ formatTime(row.createTime) }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('account_redesign.applicant')" prop="applyUser" width="120" show-overflow-tooltip>
                            <template #default="{ row }">{{ row.applyUser || '-' }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('account_redesign.auditor')" prop="auditUser" width="120" show-overflow-tooltip>
                            <template #default="{ row }">{{ row.auditUser || '-' }}</template>
                        </el-table-column>
                        <el-table-column :label="$t('account_redesign.actions')" width="180" fixed="right" align="center">
                            <template #default="{ row }">
                                <template v-if="row.status === 0">
                                    <el-button type="text" icon="el-icon-edit" size="small"
                                        :title="$t('account_redesign.audit')" @click="openAuditDialog(row)"></el-button>
                                    <el-button type="text" icon="el-icon-circle-check" size="small"
                                        :title="$t('account_redesign.approve_icon')"
                                        :style="{ color: '#67c23a' }"
                                        @click="handleQuickAudit(row, 'approve')"></el-button>
                                    <el-button type="text" icon="el-icon-circle-close" size="small"
                                        :title="$t('account_redesign.reject_icon')"
                                        :style="{ color: '#f56c6c' }"
                                        @click="handleQuickAudit(row, 'reject')"></el-button>
                                </template>
                                <template v-else>
                                    <el-button type="text" icon="el-icon-tickets" size="small"
                                        :title="$t('account_redesign.view_detail')" @click="openDetailDialog(row)"></el-button>
                                    <el-button type="text" icon="el-icon-delete" size="small"
                                        :title="$t('account_redesign.delete_icon')"
                                        :style="{ color: '#f56c6c' }"
                                        @click="handleSingleDelete(row)"></el-button>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>

                    <Pagination class="pagination" :total="applyTotal"
                        :page.sync="applySearchForm.iDisplayStart" :limit.sync="applySearchForm.iDisplayLength"
                        @pagination="fetchApplyList" />
                </div>
            </el-tab-pane>

            <!-- Tab 2: Enterprise List (migrated from System > Company) -->
            <el-tab-pane :label="$t('account_redesign.company_list')" name="company">
                <CustomerPage v-if="activeTab === 'company'" />
            </el-tab-pane>
        </el-tabs>

        <!-- 新增申请弹窗 -->
        <modal :title="$t('account_redesign.apply_form_title')" :visible.sync="applyDialogVisible" width="600px"
            :close-on-click-modal="false" append-to-body>
            <p class="form-tip">{{ $t('account_redesign.apply_form_tip') }}</p>
            <el-form ref="applyForm" :model="applyForm" :rules="applyFormRules" label-width="140px" label-position="right">
                <el-form-item :label="$t('account_redesign.company_name')" prop="companyName">
                    <el-input v-model.trim="applyForm.companyName" maxlength="200"
                        :placeholder="$t('account_redesign.company_name')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.contact_name')" prop="contactName">
                    <el-input v-model.trim="applyForm.contactName" maxlength="80"
                        :placeholder="$t('account_redesign.contact_name')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.mobile')" prop="contactMobile">
                    <el-input v-model.trim="applyForm.contactMobile" maxlength="20"
                        :placeholder="$t('account_redesign.mobile')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.contact_email')" prop="contactEmail">
                    <el-input v-model.trim="applyForm.contactEmail" maxlength="100"
                        :placeholder="$t('account_redesign.contact_email')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.apply_description')" prop="description">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6 }" v-model.trim="applyForm.description"
                        maxlength="500" show-word-limit
                        :placeholder="$t('account_redesign.apply_description')"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="applyDialogVisible = false">{{ $t('account_redesign.close') }}</el-button>
                <el-button type="primary" :loading="applySubmitting" @click="handleApplySubmit">
                    {{ $t('account_redesign.ok') }}
                </el-button>
            </div>
        </modal>

        <!-- 单条审核弹窗 -->
        <modal :title="$t('account_redesign.apply_record_audit')" :visible.sync="auditDialogVisible" width="600px"
            :close-on-click-modal="false" append-to-body>
            <el-form label-width="140px" label-position="right" v-if="currentApply">
                <el-form-item :label="$t('account_redesign.company_name')">
                    <span>{{ currentApply.companyName }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.contact_name')">
                    <span>{{ currentApply.contactName }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.mobile')">
                    <span>{{ currentApply.contactMobile }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.contact_email')">
                    <span>{{ currentApply.contactEmail }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.apply_description')" v-if="currentApply.description">
                    <span>{{ currentApply.description }}</span>
                </el-form-item>
            </el-form>
            <el-divider></el-divider>
            <el-form label-width="140px" label-position="right">
                <el-form-item :label="$t('account_redesign.audit_result')">
                    <div class="audit-radio-group">
                        <div class="audit-radio-item" :class="{ active: auditForm.result === 'approve' }"
                            @click="auditForm.result = 'approve'">
                            <i class="el-icon-circle-check approve-icon"></i>
                            <span>{{ $t('account_redesign.approve') }}</span>
                        </div>
                        <div class="audit-radio-item" :class="{ active: auditForm.result === 'reject' }"
                            @click="auditForm.result = 'reject'">
                            <i class="el-icon-circle-close reject-icon"></i>
                            <span>{{ $t('account_redesign.reject') }}</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.audit_remark')">
                    <el-input type="textarea" v-model="auditForm.remark" :rows="3" maxlength="500" show-word-limit
                        :placeholder="$t('account_redesign.audit_remark_placeholder')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="auditForm.notifyEmail">{{ $t('account_redesign.notify_email') }}</el-checkbox>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="auditDialogVisible = false">{{ $t('account_redesign.close') }}</el-button>
                <el-button type="primary" :loading="auditSubmitting" @click="handleAudit">
                    {{ $t('account_redesign.ok') }}
                </el-button>
            </div>
        </modal>

        <!-- 批量审核弹窗 -->
        <modal :title="$t('account_redesign.batch_audit_title')" :visible.sync="batchAuditDialogVisible" width="560px"
            :close-on-click-modal="false" append-to-body>
            <div class="batch-tip">
                <i class="el-icon-warning-outline"></i>
                <span>{{ $t('account_redesign.batch_audit_tip', { count: selectedApplyIds.length }) }}</span>
            </div>
            <el-form label-width="140px" label-position="right">
                <el-form-item :label="$t('account_redesign.audit_result')">
                    <div class="audit-radio-group">
                        <div class="audit-radio-item" :class="{ active: batchAuditForm.result === 'approve' }"
                            @click="batchAuditForm.result = 'approve'">
                            <i class="el-icon-circle-check approve-icon"></i>
                            <span>{{ $t('account_redesign.approve') }}</span>
                        </div>
                        <div class="audit-radio-item" :class="{ active: batchAuditForm.result === 'reject' }"
                            @click="batchAuditForm.result = 'reject'">
                            <i class="el-icon-circle-close reject-icon"></i>
                            <span>{{ $t('account_redesign.reject') }}</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.audit_remark')">
                    <el-input type="textarea" v-model="batchAuditForm.remark" :rows="3" maxlength="500" show-word-limit
                        :placeholder="$t('account_redesign.audit_remark_placeholder')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="batchAuditForm.notifyEmail">{{ $t('account_redesign.notify_email') }}</el-checkbox>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="batchAuditDialogVisible = false">{{ $t('account_redesign.close') }}</el-button>
                <el-button type="primary" :loading="batchAuditSubmitting" @click="handleBatchAudit">
                    {{ $t('account_redesign.ok') }}
                </el-button>
            </div>
        </modal>

        <!-- 详情弹窗 -->
        <modal :title="$t('account_redesign.apply_record_detail')" :visible.sync="detailDialogVisible" width="560px"
            append-to-body>
            <el-form label-width="140px" label-position="right" v-if="currentApply">
                <el-form-item :label="$t('account_redesign.company_name')">
                    <span>{{ currentApply.companyName }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.apply_status')">
                    <i :class="getApplyStatusIcon(currentApply.status).icon"
                        :style="{ color: getApplyStatusIcon(currentApply.status).color, fontSize: '18px' }"></i>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.company_id')" v-if="currentApply.companyId">
                    <span>{{ currentApply.companyId }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.contact_name')">
                    <span>{{ currentApply.contactName }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.mobile')">
                    <span>{{ currentApply.contactMobile }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.contact_email')">
                    <span>{{ currentApply.contactEmail }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.applicant')">
                    <span>{{ currentApply.applyUser || '-' }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.auditor')">
                    <span>{{ currentApply.auditUser || '-' }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.apply_time')">
                    <span>{{ formatTime(currentApply.createTime) }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.apply_description')" v-if="currentApply.description">
                    <span>{{ currentApply.description }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.audit_remark')" v-if="currentApply.auditRemark">
                    <span>{{ currentApply.auditRemark }}</span>
                </el-form-item>
                <el-form-item :label="$t('account_redesign.audit_time')" v-if="currentApply.auditTime">
                    <span>{{ formatTime(currentApply.auditTime) }}</span>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button type="primary" @click="detailDialogVisible = false">{{ $t('account_redesign.close') }}</el-button>
            </div>
        </modal>
    </div>
</template>

<script>
import {
    listCompanyApply,
    auditCompanyApply,
    batchAuditCompanyApply,
    batchDeleteCompanyApply,
    createCompanyApply
} from '@/api/modules/account.js'
import tableMixins from '@/utils/tableMixins.js'
import CustomerPage from '@/pages/system/customer/Customer.vue'

export default {
    name: 'EnterpriseAdmin',
    components: { CustomerPage },
    mixins: [tableMixins],
    data() {
        return {
            activeTab: 'apply',
            tableHeight: 'calc(100% - 60px)',
            applyLoading: false,
            applyList: [],
            applyTotal: 0,
            applySearchForm: { keyword: null, status: null, iDisplayStart: 0, iDisplayLength: 15 },
            applyStatusArray: [
                { value: '', label: 'public.please', icon: 'el-icon-thumb' },
                { value: 0, label: 'account_redesign.status_pending', icon: 'el-icon-time', color: '#e6a23c' },
                { value: 1, label: 'account_redesign.status_approved', icon: 'el-icon-circle-check', color: '#67c23a' },
                { value: 2, label: 'account_redesign.status_rejected', icon: 'el-icon-circle-close', color: '#f56c6c' }
            ],
            // 下拉按钮配置（参照 UAM Role 的 v-button 风格）
            optareBtn: [
                { id: 1, text: 'account_redesign.apply', method: 'applyFn', icon: 'el-icon-plus' },
                { id: 2, text: 'account_redesign.audit_batch', method: 'auditFn', icon: 'el-icon-s-check' },
                { id: 3, text: 'account_redesign.delete', method: 'deleteFn', icon: 'el-icon-delete' }
            ],
            // 选中项
            selectedApplies: [],
            selectedApplyIds: [],
            // 新增申请弹窗
            applyDialogVisible: false,
            applySubmitting: false,
            applyForm: { companyName: '', contactName: '', contactMobile: '', contactEmail: '', description: '' },
            // 单条审核弹窗
            auditDialogVisible: false,
            auditSubmitting: false,
            currentApply: null,
            auditForm: { result: 'approve', remark: '', notifyEmail: true },
            // 批量审核弹窗
            batchAuditDialogVisible: false,
            batchAuditSubmitting: false,
            batchAuditForm: { result: 'approve', remark: '', notifyEmail: true },
            // 详情弹窗
            detailDialogVisible: false
        }
    },
    computed: {
        currentUserAccount() {
            return this.$store.state.user ? (this.$store.state.user.account || this.$store.state.user.name || '') : ''
        },
        applyFormContent() {
            return [
                { id: 1, text: 'account_redesign.company_name', type: 'input', paramsName: 'keyword', isChooze: true },
                { id: 2, text: 'account_redesign.apply_status', type: 'select', paramsName: 'status', isChooze: false,
                  selectParam: this.applyStatusArray }
            ]
        },
        applyFormRules() {
            return {
                companyName: [{ required: true, message: this.$t('account_redesign.company_name'), trigger: 'blur' }],
                contactName: [{ required: true, message: this.$t('account_redesign.contact_name'), trigger: 'blur' }],
                contactMobile: [{ required: true, message: this.$t('account_redesign.mobile'), trigger: 'blur' }],
                contactEmail: [
                    { required: true, message: this.$t('account_redesign.contact_email'), trigger: 'blur' },
                    { type: 'email', message: this.$t('account_redesign.contact_email'), trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        this.fetchApplyList()
    },
    methods: {
        // 将审批错误码映射为 i18n 消息，避免直接显示后端固定语言消息
        getAuditErrorMsg (code) {
            const codeMap = {
                400058: 'account_redesign.audit_err_name_conflict',
                400059: 'account_redesign.audit_err_code_conflict',
                400060: 'account_redesign.audit_err_email_conflict',
                400061: 'account_redesign.audit_err_phone_conflict',
                400044: 'account_redesign.audit_err_not_found',
                400045: 'account_redesign.audit_err_already_processed'
            }
            if (code && codeMap[code]) {
                return this.$t(codeMap[code])
            }
            return null
        },
        getApplyStatusIcon(status) {
            const map = {
                0: { icon: 'el-icon-time', color: '#e6a23c' },
                1: { icon: 'el-icon-circle-check', color: '#67c23a' },
                2: { icon: 'el-icon-circle-close', color: '#f56c6c' }
            }
            return map[status] || { icon: 'el-icon-question', color: '#909399' }
        },
        async fetchApplyList() {
            this.applyLoading = true
            try {
                const page = Math.floor(this.applySearchForm.iDisplayStart / this.applySearchForm.iDisplayLength)
                const res = await listCompanyApply({
                    keyword: this.applySearchForm.keyword || undefined,
                    status: this.applySearchForm.status !== null && this.applySearchForm.status !== '' ? this.applySearchForm.status : undefined,
                    page: page,
                    size: this.applySearchForm.iDisplayLength
                })
                if (res && res.state && res.state.code === 200) {
                    this.applyList = res.result || []
                    const pi = res.pageInfo
                    this.applyTotal = pi ? pi.total : 0
                } else {
                    this.applyList = []
                    this.applyTotal = 0
                }
            } catch (e) {
                console.error('fetch apply list error:', e)
                this.applyList = []
                this.applyTotal = 0
            } finally {
                this.applyLoading = false
            }
        },
        applySearchFn() { this.applySearchForm.iDisplayStart = 0; this.fetchApplyList() },
        applyConfirmFn() { this.applySearchForm.iDisplayStart = 0; this.fetchApplyList() },
        applyResetFn() {
            this.applySearchForm = { keyword: null, status: null, iDisplayStart: 0, iDisplayLength: 15 }
            this.fetchApplyList()
        },
        handleSelectionChange(selection) {
            this.selectedApplies = selection
            this.selectedApplyIds = selection.map(item => item.id)
        },
        // 新增申请（发送 camelCase 字段名，与全局命名策略一致）
        openApplyDialog() {
            this.applyForm = { companyName: '', contactName: '', contactMobile: '', contactEmail: '', description: '' }
            this.applyDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.applyForm) this.$refs.applyForm.clearValidate()
            })
        },
        async handleApplySubmit() {
            this.$refs.applyForm.validate(async valid => {
                if (!valid) return
                this.applySubmitting = true
                try {
                    const res = await createCompanyApply({
                        companyName: this.applyForm.companyName,
                        contactName: this.applyForm.contactName,
                        contactMobile: this.applyForm.contactMobile,
                        contactEmail: this.applyForm.contactEmail,
                        description: this.applyForm.description
                    })
                    if (res && res.state && res.state.code === 200) {
                        this.$message.success(this.$t('account_redesign.apply_success'))
                        this.applyDialogVisible = false
                        this.fetchApplyList()
                    }
                } catch (e) {
                    console.error('apply error:', e)
                } finally {
                    this.applySubmitting = false
                }
            })
        },
        // 单条审核
        openAuditDialog(row) {
            this.currentApply = row
            this.auditForm = { result: 'approve', remark: '', notifyEmail: true }
            this.auditDialogVisible = true
        },
        async handleAudit() {
            this.auditSubmitting = true
            try {
                const res = await auditCompanyApply({
                    applyId: this.currentApply.id,
                    result: this.auditForm.result,
                    remark: this.auditForm.remark,
                    notifyEmail: this.auditForm.notifyEmail,
                    language: this.$i18n ? this.$i18n.locale : 'en_US'
                })
                if (res && res.state && res.state.code === 200) {
                    this.$message.success(this.$t('account_redesign.confirm') + ' OK')
                    this.auditDialogVisible = false
                    this.fetchApplyList()
                } else if (res && res.state) {
                    this.$message.error(this.getAuditErrorMsg(res.state.code) || res.state.msg || this.$t('account_redesign.audit_failed'))
                }
            } catch (e) {
                console.error('audit error:', e)
                const errCode = e && e.response && e.response.data && e.response.data.state && e.response.data.state.code
                const msg = e && e.response && e.response.data && e.response.data.state && e.response.data.state.msg
                this.$message.error(this.getAuditErrorMsg(errCode) || msg || this.$t('account_redesign.audit_failed'))
            } finally {
                this.auditSubmitting = false
            }
        },
        // 快速审核（Actions列 Approve/Reject icon）
        async handleQuickAudit(row, result) {
            const tipKey = result === 'approve' ? 'account_redesign.tip_audit_approve' : 'account_redesign.tip_audit_reject'
            try {
                await this.$confirm(this.$t(tipKey), this.$t('account_redesign.audit'), {
                    confirmButtonText: this.$t('account_redesign.confirm'),
                    cancelButtonText: this.$t('account_redesign.cancel'),
                    type: result === 'approve' ? 'success' : 'warning'
                })
            } catch {
                return
            }
            try {
                const res = await auditCompanyApply({
                    applyId: row.id,
                    result: result,
                    remark: '',
                    notifyEmail: true,
                    language: this.$i18n ? this.$i18n.locale : 'en_US'
                })
                if (res && res.state && res.state.code === 200) {
                    this.$message.success(this.$t('account_redesign.confirm') + ' OK')
                    this.fetchApplyList()
                } else if (res && res.state) {
                    this.$message.error(this.getAuditErrorMsg(res.state.code) || res.state.msg || this.$t('account_redesign.audit_failed'))
                }
            } catch (e) {
                console.error('quick audit error:', e)
                const errCode = e && e.response && e.response.data && e.response.data.state && e.response.data.state.code
                const msg = e && e.response && e.response.data && e.response.data.state && e.response.data.state.msg
                this.$message.error(this.getAuditErrorMsg(errCode) || msg || this.$t('account_redesign.audit_failed'))
            }
        },
        // 批量审核
        openBatchAuditDialog() {
            if (this.selectedApplyIds.length === 0) {
                this.$message.warning(this.$t('account_redesign.select_at_least_one'))
                return
            }
            const hasProcessed = this.selectedApplies.some(item => item.status !== 0)
            if (hasProcessed) {
                this.$message.warning(this.$t('account_redesign.batch_delete_pending_tip'))
                return
            }
            this.batchAuditForm = { result: 'approve', remark: '', notifyEmail: true }
            this.batchAuditDialogVisible = true
        },
        async handleBatchAudit() {
            this.batchAuditSubmitting = true
            try {
                const res = await batchAuditCompanyApply({
                    applyIds: this.selectedApplyIds,
                    result: this.batchAuditForm.result,
                    remark: this.batchAuditForm.remark,
                    notifyEmail: this.batchAuditForm.notifyEmail,
                    language: this.$i18n ? this.$i18n.locale : 'en_US'
                })
                if (res && res.state && res.state.code === 200) {
                    this.$message.success(this.$t('account_redesign.confirm') + ' OK')
                    this.batchAuditDialogVisible = false
                    this.fetchApplyList()
                } else if (res && res.state) {
                    this.$message.error(this.getAuditErrorMsg(res.state.code) || res.state.msg || this.$t('account_redesign.audit_failed'))
                }
            } catch (e) {
                console.error('batch audit error:', e)
                const errCode = e && e.response && e.response.data && e.response.data.state && e.response.data.state.code
                const msg = e && e.response && e.response.data && e.response.data.state && e.response.data.state.msg
                this.$message.error(this.getAuditErrorMsg(errCode) || msg || this.$t('account_redesign.audit_failed'))
            } finally {
                this.batchAuditSubmitting = false
            }
        },
        // 批量删除
        async handleBatchDelete() {
            if (this.selectedApplyIds.length === 0) {
                this.$message.warning(this.$t('account_redesign.select_at_least_one'))
                return
            }
            const hasPending = this.selectedApplies.some(item => item.status === 0)
            if (hasPending) {
                this.$message.warning(this.$t('account_redesign.batch_delete_pending_tip'))
                return
            }
            try {
                await this.$confirm(this.$t('account_redesign.batch_delete_confirm'), this.$t('account_redesign.batch_delete_title'), {
                    confirmButtonText: this.$t('account_redesign.confirm'),
                    cancelButtonText: this.$t('account_redesign.cancel'),
                    type: 'warning'
                })
            } catch {
                return
            }
            try {
                const res = await batchDeleteCompanyApply({ applyIds: this.selectedApplyIds })
                if (res && res.state && res.state.code === 200) {
                    this.$message.success(this.$t('account_redesign.confirm') + ' OK')
                    this.fetchApplyList()
                }
            } catch (e) {
                console.error('batch delete error:', e)
            }
        },
        // 单条删除（已审核记录）
        async handleSingleDelete(row) {
            try {
                await this.$confirm(this.$t('account_redesign.batch_delete_confirm'), this.$t('account_redesign.delete'), {
                    confirmButtonText: this.$t('account_redesign.confirm'),
                    cancelButtonText: this.$t('account_redesign.cancel'),
                    type: 'warning'
                })
            } catch {
                return
            }
            try {
                const res = await batchDeleteCompanyApply({ applyIds: [row.id] })
                if (res && res.state && res.state.code === 200) {
                    this.$message.success(this.$t('account_redesign.confirm') + ' OK')
                    this.fetchApplyList()
                }
            } catch (e) {
                console.error('delete error:', e)
            }
        },
        openDetailDialog(row) {
            this.currentApply = row
            this.detailDialogVisible = true
        },
        formatTime(time) {
            if (!time) return '-'
            const d = new Date(time)
            const pad = (n) => String(n).padStart(2, '0')
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
        }
    }
}
</script>

<style lang="scss" scoped>
.enterprise-admin-page {
    height: 100%;
    width: 100%;
    padding: 10px 15px 0 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    ::v-deep .el-tabs {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .el-tabs__header { margin-bottom: 0; }
        .el-tabs__content { flex: 1; overflow: hidden; }
        .el-tab-pane { height: 100%; display: flex; flex-direction: column; }
    }

    .rightHeader {
        position: relative;
    }

    .componentPage {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}

.form-tip {
    color: #909399;
    font-size: 13px;
    margin-bottom: 15px;
    padding: 8px 12px;
    background: #f4f4f5;
    border-radius: 4px;
}

.batch-tip {
    color: #e6a23c;
    font-size: 13px;
    margin-bottom: 15px;
    padding: 8px 12px;
    background: #fdf6ec;
    border-radius: 4px;
    border: 1px solid #f5dab1;

    i { margin-right: 5px; }
}

/* 审核结果选择卡片样式 */
.audit-radio-group {
    display: flex;
    gap: 15px;

    .audit-radio-item {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 10px 20px;
        border: 2px solid #e4e7ed;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;
        background: #fff;
        min-width: 120px;
        justify-content: center;

        i { font-size: 20px; }
        .approve-icon { color: #67c23a; }
        .reject-icon { color: #f56c6c; }
        span { font-size: 14px; color: #606266; }

        &:hover {
            border-color: var(--primary-color);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        }

        &.active {
            border-color: var(--primary-color);
            background: rgba(var(--primary-color-rgb, 64, 158, 255), 0.05);
            box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

            span { color: var(--primary-color); font-weight: 600; }
        }
    }
}
</style>

<style lang="scss">
/* Modal 内 form label 样式覆盖 */
.enterprise-admin-page {
    ::v-deep .el-form-item__label {
        white-space: nowrap;
        text-align: right;
    }
}
</style>
